import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const includes: string[] = ['El Plan de 72 Horas completo', 'Los Horarios por edad (0-24 meses)', 'La Guía de Consuelo sin llanto solitario', 'Acceso de por vida + futuras actualizaciones'];
export function PriceClose() {
  return <section id="comprar" className="w-full bg-slateblue-900 py-16 sm:py-20" aria-labelledby="price-title" data-id="element-67" data-mp="ija2aq5uqs1r">
      <div className="mx-auto max-w-3xl px-5" data-id="element-68" data-mp="8myp7xyfty69">
        <div className="rounded-3xl bg-cream p-7 shadow-2xl sm:p-10" data-id="element-69" data-mp="8orxfhop8qgd">
          <div className="text-center" data-id="element-70" data-mp="3qtlfnnox3bfb">
            <p className="text-[15px] leading-relaxed text-slateblue-600" data-id="element-71" data-mp="3quo31ln16vqh">
              Esto no te costará los{' '}
              <span className="font-semibold text-slateblue-900" data-id="element-72" data-mp="3vtr999eqz801">$200</span> que
              cobra una consultora privada de sueño.
            </p>
            <p className="mt-1 text-[15px] leading-relaxed text-slateblue-600" data-id="element-73" data-mp="1tziab741yvkt">
              Ni siquiera los{' '}
              <span className="font-semibold text-slateblue-900" data-id="element-74" data-mp="2akntaxnkcowe">$27</span> que
              es el precio regular de esta guía.
            </p>

            <h2 id="price-title" className="mt-7 font-display text-xl font-bold text-slateblue-900" data-id="element-75" data-mp="2kc0jlktpr70b">
              Obtén acceso instantáneo hoy por solo:
            </h2>
            <p className="mt-2 font-display text-6xl font-black leading-none text-coral sm:text-7xl" data-id="element-76" data-mp="1rn375yc6o4fh">
              $6.39
            </p>
            <p className="mt-3 text-sm font-medium text-slateblue-600" data-id="element-77" data-mp="1nn2n9y6bf111">
              Pago único. Sin suscripciones. Sin cargos ocultos.
            </p>
          </div>

          <ul className="mx-auto mt-8 max-w-md space-y-2.5" data-id="element-78" data-mp="1wlwflccm558s">
            {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-slateblue-900" data-id="element-79" data-mp="3czwgapja8yx3">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-80" data-mp="381cpaapu0wxv" />
                {item}
              </li>)}
          </ul>

          <div className="mx-auto mt-8 max-w-md" data-id="element-81" data-mp="3p2z33en1x8lj">
            <CtaButton data-id="element-82" data-mp="3p4a4x8wxs6a0" />
          </div>

          <div className="mt-9 flex flex-col items-center gap-4 rounded-2xl border border-slateblue-100 bg-white p-6 text-center sm:flex-row sm:text-left" data-id="element-83" data-mp="3p15wu0gcoqe2">
            <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-slateblue-50 text-slateblue-600" data-id="element-84" data-mp="2wfme6xtf4op2">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-85" data-mp="31b1qhlbs2cjd" />
            </span>
            <div data-id="element-86" data-mp="36aee48ah3nn0">
              <h3 className="font-display text-lg font-bold text-slateblue-900" data-id="element-87" data-mp="3b37iuw5xyvz3">
                Nuestra Promesa de Descanso
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-slateblue-600" data-id="element-88" data-mp="2dn0o6u56zsce">
                Si después de 7 días aplicando el protocolo no ves una mejora
                clara en el sueño de tu bebé, te devolvemos tus{' '}
                <span className="font-semibold text-slateblue-900" data-id="element-89" data-mp="2b2m4mmt2migy">$6.39</span>{' '}
                íntegros. Sin preguntas, sin complicaciones. El riesgo es 100%
                nuestro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}